import { render, staticRenderFns } from "./Uploads.vue?vue&type=template&id=2e15f336"
import script from "./Uploads.vue?vue&type=script&lang=js"
export * from "./Uploads.vue?vue&type=script&lang=js"
import style0 from "./Uploads.vue?vue&type=style&index=0&id=2e15f336&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports